module.exports = __webpack_public_path__ + "static/media/emergency-contact.90cf005f.svg";